import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { createLocation, updateLocation, deleteLocation } from '@/redux/actions';

const WS_LOCATIONS_BY_HTTP = {
	CREATE_LOCATION: `locations/POST`,
	UPDATE_LOCATION: `locations/:locationID/PATCH`,
	DELETE_LOCATION: `locations/:locationID/DELETE`,
};

const CheckInsSubscriptions = props => {
	const {
		socket,
		children,
		currentEventId,
		locations,
		createLocation,
		updateLocation,
		deleteLocation,
	} = props;

	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToCheckIns = () => {
		socket.emit('event/checkins/:eventID/SUBSCRIBE', { eventID: currentEventId, locations });
		console.log('⚡️ CheckInsSubscriptions Mounted ⚡️', locations);
	};

	const unsubscribeToCheckIns = () => {
		socket.emit('event/checkins/:eventID/UNSUBSCRIBE', { eventID: currentEventId, locations });
		console.log(`🚶‍♂️ CheckInsSubscriptions Unmounted 🚶‍♂️`, locations);
	};

	const listenForCreatedLocation = () => {
		console.log(WS_LOCATIONS_BY_HTTP.CREATE_LOCATION, 'running');
		socket.on(WS_LOCATIONS_BY_HTTP.CREATE_LOCATION, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`location could not be created`, error);
			else {
				const { name } = data;
				createLocation(data);
				displayMessage(`${name} created`);
			}
		});
	};

	const listenForUpdatedLocation = () => {
		socket.on(WS_LOCATIONS_BY_HTTP.UPDATE_LOCATION, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`location could not be updated`, error);
			else {
				const { name } = data;
				updateLocation(data);
				displayMessage(`${name} updated`);
			}
		});
	};

	const listenForDeletedLocation = () => {
		socket.on(WS_LOCATIONS_BY_HTTP.DELETE_LOCATION, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`location could not be deleted`, error);
			else {
				const { deleteLocation: location, locationName } = data;
				deleteLocation(location.id);
				displayMessage(`${locationName} succesfully deleted`);
			}
		});
	};

	const listeners = () => [
		listenForCreatedLocation,
		listenForUpdatedLocation,
		listenForDeletedLocation,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToCheckIns}
				unsub={unsubscribeToCheckIns}
				listeners={listeners()}
				routes={Object.values(WS_LOCATIONS_BY_HTTP)}
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	createLocation: (location, from) => dispatch(createLocation(location, from)),
	updateLocation: (location, from) => dispatch(updateLocation(location, from)),
	deleteLocation: (locationID, from) => dispatch(deleteLocation(locationID, from)),
});

export default connect(msp, mdp)(CheckInsSubscriptions);
